<template>
    <div class="page" id="search-create">
        <div class="decorative-texture top">
            <img src="../assets/img/texture.png" />
        </div>
        <loading :active.sync="isLoading" :can-cancel=false :is-full-page=true background-color="#EBF9FF" color="#02B99E">
        </loading>
        <vue-snotify></vue-snotify>
        <side-menu :menuOn="menuOn" @menuVisible="menuVisible"></side-menu>
        <mnavbar @menuVisible="menuVisible"></mnavbar>
        <section class="container-fluid noPadding">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-sm-12 col-md-10 ">
                        <h1 class="section-title"></h1>
                        <div class="card head-card create-container ">
                            <div class="title-card">
                                <h4>Guardar en newsletter</h4>
                            </div>
                            <div class="card-content">
                                <div class="create-info">
                                    <h2 class="title info-title">Guardar en </h2>
                                    <p class="subtitle greenBlue">A continuación seleccione el newsletter</p>

                                    <p class="subtitle">¿Deseas guardar esta nota para ver más tarde?</p>
                                    <!--<div class="row">
                                        <div class="col-12" style="padding-right:0">
                                            <div class="input-field" style="width:100%">
                                                
                                                <input type="text" placeholder="Nombre de carpeta" v-model="newFolderName">
                                            </div>
                                        </div>

                                    </div>

                                    <div class="col-12 text-center">
                                        <button class=" button alternative" @click="crearFolder">
                                            Crear Newsletter
                                        </button>
                                    </div>-->
                                </div>
                                <div class="proyects-list">
                                <div v-for="(cap, index) in newsletters" :key="index" class="card greenBlue">
                                    <div 
                                        class="folder-header"
                                        :class="{ 'is-selected-parent': selectedFolder === cap.nombre }"
                                        @click="selectParent(cap)"
                                    >
                                        <span>{{ openedFolders[index] ? '📂' : '📁' }}</span>
                                        <span class="label-text">{{ cap.nombre }}</span>
                                    </div>

                                    <ul v-if="openedFolders[index]" class="sub-list">
                                        <li 
                                        v-for="(sub, sIndex) in cap.subtitulos" 
                                        :key="sIndex"
                                        class="sub-item"
                                        :class="[ (selectedSubtitle === sub ) ? 'is-selected-child' : '' ]"
                                        @click="selectChild(sub)"
                                        >
                                        {{ sub }}
                                        </li>
                                    </ul>
                                    </div>

                                    <hr>
    <!--<p><strong>Padre seleccionado:</strong> {{ selectedFolder || 'Ninguno' }}</p>
    <p><strong>Hijo seleccionado:</strong> {{ selectedSubtitle || 'Ninguno' }}</p>

                                    <div :class="[customClass, (folderKey === item.orden) ? folderSelected : '']"
                                        v-for="item in newsletters" :key="item.orden"
                                        @click="setFolder(item.orden, item.nombre)">
                                        <div class="row align-items-center">
                                            <div class="col-sm-1 col-md-2 proyects-icon"
                                                style="text-align:center;padding-left: 0;">
                                                <div class="icon-container">
                                                    <div class="user-avatar">
                                                        <div class="img-avatar">
                                                            <img :class="[{ noBorderRadius: true }]"
                                                                :src="getImagen()" alt="Avatar" class="image" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-11 col-md-10 proyect-description">
                                                <h1 class="subtitle">{{ item.nombre }}</h1>
                                                <p class="paragraph dark">{{ getActualizacion(item) }}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="button-circle-more primary" style="margin-top:5%" v-if="LastEvaluatedKey">
                                        <button class="circle-more" @click="loadMore">
                                            <svg viewBox="0 0 18 18">
                                                <g id="Grupo_29" data-name="Grupo 29" transform="translate(-171 -753)">
                                                    <rect id="Rectángulo_redondeado_903"
                                                        data-name="Rectángulo redondeado 903" width="2" height="18" rx="1"
                                                        transform="translate(179 753)" />
                                                    <rect id="Rectángulo_redondeado_903_copia"
                                                        data-name="Rectángulo redondeado 903 copia" width="18" height="2"
                                                        rx="1" transform="translate(171 761)" />
                                                </g>
                                            </svg>
                                        </button>
                                    </div>-->
                                    <div class="save-button">
                                        <button class="button alternative" @click="save">
                                            Guardar
                                        </button>
                                        <button class="button" @click="cancelar">
                                            Cancelar
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
import SideMenu from '@/components/sideMenu'
import mnavbar from '@/components/mnavbar'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faArchive } from '@fortawesome/free-solid-svg-icons'
library.add(faArchive)

import moment from 'moment-timezone'
export default {
    components: { mnavbar, SideMenu },
    props: ['keyNote', 'table'],
    data() {
        return {
            isLoading: false,
            newFolderName: '',
            url: this.$store.getters.getMainUrl,
            menuOn: false,
            colorIcon: 'colorIcon',
            customClass: 'card greenBlue proyects-item',
            folderSelected: 'folderSelected',
            items: [],
            total: 0,
            LastEvaluatedKey: null,
            folderKey: null,
            folderImage: '', //imagen para nueva carpeta
            folderFile: '',
            from: "",
            fromParams: {},
            extraParams: {},
            newsletters: [],
            folderName: "",
            treeData:{
                name: 'Proyecto Raíz',
                children: [
                    { name: 'src', children: [{ name: 'App.vue' }, { name: 'main.ts' }] },
                    { name: 'public', children: [{ name: 'index.html' }] },
                    { name: 'package.json' }
                ]
            },
            isOpen: false,
            // Estado para controlar qué carpetas están expandidas
      openedFolders: {},
      // Arrays para almacenar las selecciones independientes
      selectedFolder: null,
      selectedSubtitle: null,

        }
    },
    computed: {
        token() {
            return this.$store.getters.getToken;
        },
        isFolder() {
            return this.treeData.children && this.treeData.children.length > 0;
        }
    },
    beforeMount() {
        var backData2 = this.$store.state.backData2;
        var d = backData2.length > 0 ? backData2[backData2.length - 1] : {};
        this.from = d.from;
        this.fromParams = d.fromParams;
        this.extraParams = d.extraParams;
    },
    mounted() {
        if (this.keyNote != undefined)
            this.loadItems();
        else
            this.cancelar();
    },
    methods: {
        selectParent(carpeta) {
            if (this.folderKey == carpeta.orden) {
                this.folderKey = null;
                this.folderName = null;
            } else {
                this.folderKey = carpeta.orden;
                this.folderName = carpeta.nombre;
            }
      // 1. Alternar apertura (opcional, si quieres que se abra al clic)
      const index = this.newsletters.indexOf(carpeta);
      this.$set(this.openedFolders, index, !this.openedFolders[index]);

      // 2. Lógica de selección única: si es el mismo, lo quita; si es otro, lo reemplaza
      this.selectedFolder = this.selectedFolder === carpeta.nombre ? null : carpeta.nombre;
      
      // Opcional: Limpiar el hijo si cambias de padre
      // this.selectedSubtitle = null; 
    },
    selectChild(sub) {
      // Lógica de selección única para el hijo
      console.log("##################### IN");
      console.log(sub);
      console.log(this.selectedSubtitle);
      this.selectedSubtitle = this.selectedSubtitle === sub ? null : sub;
      console.log("##################### out");
      console.log(this.selectedSubtitle);
    },
        toggle() {
            this.isOpen = !this.isOpen;
        },
        async loadItems() {
            
            this.isLoading = true;
            var formData = {
                id: this.$store.state.userInfo.id,
            };
            await axios
                .post(
                    this.url + "getnewsletteruser",
                    formData
                ) //petición
                .then((response) => {
                    this.newsletters = response.data.data;

                })
                .catch(function (error) {
                    console.log(error);
                });
            this.isLoading = false;

        },
        getActualizacion(item) {
            var modified = item.modified ? item.modified : item.created;
            var tmp = moment(modified);
            var fecha = moment.tz(tmp, 'America/Mexico_City').format('dddd, D MMMM YYYY');
            return fecha;
        },
        setFolder(key, name) {
            console.log(key);
            if (this.folderKey == key) {
                this.folderKey = null;
                this.folderName = null;
            } else {
                this.folderKey = key;
                this.folderName = name;
            }
        },
        saves () {
            console.log(this.selectedFolder , this.selectedSubtitle)
            if (this.folderKey) {
                var formQuery = {
                    key: this.folderKey,
                    nota_id: this.keyNote,
                    table_nota: this.table,
                    flag: true,
                    nombre: this.folderName,
                    subtitulo: this.selectedSubtitle
                };
                console.log(formQuery);
            } else {
                this.error("Es necesario seleccionar un newsletter");
            }
        },
        async save() {

            if (this.folderKey) {
                this.isLoading = true;
                var formQuery = {
                    key: this.folderKey,
                    nota_id: this.keyNote,
                    table_nota: this.table,
                    flag: true,
                    nombre: this.folderName,
                    subtitulo: this.selectedSubtitle
                };
                await axios
                    .post(
                        this.url + "add_item_newsletter",
                        formQuery
                    ).then((response) => {
                        if (response.data.success) {
                            this.success(`Agregado correctamente a ${this.folderName}`);
                            setTimeout(() => {
                                this.goBack();
                            }, "1500");
                        } else {
                            this.error(response.data.body);
                        }

                    })
                    .catch(function (error) {
                        console.log(error);
                        this.error("Intente nuevamente");
                    });
                this.isLoading = false;
            } else {
                this.error("Es necesario seleccionar un newsletter");
            }
        },
        saveItems() {
            var post_data = {
                token: this.token,
                folderKey: this.folderKey.toString(),
                // query: this.query ? this.query : this.$store.state.query
            }
            var self = this;
            axios.post(this.url + 'addItemsToFolder', JSON.stringify(post_data)) //petición
                .then((response) => {
                    self.isLoading = false;
                    if (response.data.success) {
                        self.success('Agregado a Carpeta',);
                        self.goToFolder();
                    } else {
                        this.error(response.data.error);
                    }

                })
                .catch(function (error) {
                    self.isLoading = false;
                    var response = { success: false, error: error }
                    console.log(error);
                });
        },
        saveItem_() {
            var post_data = {
                token: this.token,
                folderKey: this.folderKey.toString(),
                noteKey: this.keyNote
            }

            var self = this;
            axios.post(this.url + 'addItemToFolder', JSON.stringify(post_data)) //petición
                .then((response) => {
                    self.isLoading = false;
                    if (response.data.success) {
                        self.success('Agregado a Carpeta');
                        self.goToFolder();
                    } else {
                        self.error(response.data.error);
                    }
                })
                .catch(function (error) {
                    self.isLoading = false;
                    var response = { success: false, error: error }
                    console.log(error);
                });
        },
        async crearFolder() {
            if (this.newFolderName.trim() == '') {
                this.error('Ingrese un nombre a la carpeta');
            }
            else {
                this.isLoading = true;
                var post_data = {
                    nombre: this.newFolderName,
                    titulo: "",
                    color: "#ffffff",
                    file: null,
                    url: "",
                    key: this.$store.state.userInfo.id,
                    height: 0,
                    width: 0,
                    lista: [],
                    editar: false,
                    name: ""
                };

                await axios
                    .post(
                        this.url + "crearnewsletter",
                        post_data
                    )
                    .then((response) => {
                        if (response.data.success) {

                            this.success(response.data.body);
                            this.loadItems();
                            this.newFolderName = "";


                        } else {

                            this.error(response.data.body);

                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });

                this.isLoading = false;

            }
        },
        loadMore() {
            if (this.LastEvaluatedKey) {
                this.loadItems();
            } else {
                this.$snotify.info('No hay más carpetas', 'Info');
            }
        },
        loadFolderImage() {
            this.$refs.folderImage.click()
        },
        onFilePicked(e) {
            const files = e.target.files

            if (files[0] !== undefined) {
                var FolderImage = files[0].name

                if (FolderImage.lastIndexOf('.') <= 0) {
                    return
                }
                const fr = new FileReader();
                fr.readAsDataURL(files[0]);

                fr.addEventListener('load', () => {
                    this.folderImage = fr.result;
                    this.folderFile = files[0];

                });
            } else {
                this.folderImage = ''
                this.folderFile = ''
            }
        },
        cancelar() {

            this.goBack();

        },
        goToFolder() {

            var folderKeyCompleted = this.folderKey.toString();
            var folderKey_arr = folderKeyCompleted.split('_');
            var folderKey = folderKey_arr[1];
            this.$router.push({ name: 'viewFolder', params: { id: folderKey } })
        },
        goBack() {
            var backData2 = this.$store.state.backData2;
            var data = backData2.pop();
            if (data == undefined) {
                this.$router.push('/main');
            } else {
                var from = data.from;
                var params = data.fromParams;
                this.$router.push({
                    name: from,
                    params: params
                });
            }
        },
        menuVisible(menu) {
            this.menuOn = menu;
        },
        error(msg) {
            this.$snotify.clear();
            this.$snotify.error(msg, this.$store.state.error);
        },
        async success(msg) {
            this.$snotify.clear();
            this.$snotify.success(msg, this.$store.state.success);
            return true;
        },
        getImagen(item) {
            var img =this.$store.state.defaultFolder ;
            return img;
        },
    }
}
</script>
<style scoped>
.folderImage:hover svg {
    color: #022534
}

.touchpad {
    cursor: pointer;
}

.image {
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 100%;

}

.colorIcon {
    color: #00B99E;
}

.proyects-item {
    cursor: pointer;
    width: 99%;
    margin: auto;
}

.folderSelected {
    background: #00B99E;
}

.folderSelected .colorIcon {
    color: #fff
}


.proyects-item:hover .colorIcon {
    color: #fff;
}

.proyects-item:hover {
    background: #00B99E;
}

#search-create .card .proyects-list .proyects-item .proyects-icon .icon-container::after {
    width: 0;
}

#search-create .card {
    max-width: 75% !important;
}

#search-create .card .proyects-list .save-button {
    margin-top: 5%;
}

/* cambios css para modo vertical y horizontal */
@media only screen and (min-width: 320px) and (max-width: 736px) {
    #search-create .card {
        max-width: 100% !important;
    }

    .proyect-description {
        text-align: center;
        margin-top: 5%;
    }
}

/* estilos para el árbol de carpetas */
.folder-header, .sub-item {
  /*padding: 8px;*/
  cursor: pointer;
  /*border-radius: 4px;*/
  transition: background 0.3s;
  margin-bottom: 8px;
}

/* Clase para el padre seleccionado */
.is-selected-parent {
  background-color: #e3f2fd;
  border-left: 4px solid #00B99E;
  color: #01927c;
  font-weight: bold;
}

/* Clase para el hijo seleccionado */
.is-selected-child {
  background-color: #f1f8e9;
  border-left: 4px solid #00B99E;
  color: #01927c;
  font-weight: bold;
}

.sub-list {
  list-style: none;
  margin-left: 30px;
  padding-left: 10px;
  border-left: 1px dashed #ccc;
}

.folder-header:hover, .sub-item:hover {
  background-color: #f5f5f5;
}
</style>